import Layout from '@/layout';
var shareInviteRouter = {
  path: '/shareInvite',
  component: Layout,
  redirect: '/shareInvite/account',
  name: 'ShareInvite',
  meta: {
    title: '分享邀约',
    icon: 'clipboard'
  },
  children: [{
    path: 'account',
    component: function component() {
      return import('@/views/shareInvite/account');
    },
    name: 'AccountList',
    meta: {
      title: '帐户',
      icon: ''
    }
  }, {
    path: 'customer',
    component: function component() {
      return import('@/views/shareInvite/customer');
    },
    name: 'CustomerList',
    meta: {
      title: '客户',
      icon: ''
    }
  }]
};
export default shareInviteRouter;